import Axios from "axios";
import { producaov2 } from "../../services/apis";
import { getUserNode } from "../../services/auth_node";

export const nameValidate = (name) => {
  if (!name || name?.length === 0) {
    return "Campo obrigatório";
  }

  if (name.indexOf(" ") < 0) {
    return "Digite o nome completo";
  }

  return "";
};

export const emailValidate = (email, completeValidation = true) => {
  const emailMistakes = () => {
    const emailDomain = email?.split("@")[1];

    const gmailPossibility = [
      "gail.com",
      "gmail.co",
      "gamil.com",
      "gmail",
      "gmai,com",
      "gmial.com",
    ];
    const voittoPossibility = [
      "voito.com.br",
      "voito.com",
      "voitto.com",
      "voito.br",
      "viotto.com.br",
      "voitot.com.br",
      "voitto,com.br",
    ];
    const yahooPossibility = [
      "yaho.com",
      "yahooo.com",
      "yahoo.co",
      "yhao.com",
      "yahoo,com",
    ];
    const hotmailPossibility = [
      "htmail.com",
      "hotmial.co",
      "htmila.com",
      "hotmali",
      "htomail.com",
      "hotmail",
    ];

    if (gmailPossibility.includes(emailDomain)) {
      return "Você quis dizer @gmail.com ?";
    } else if (voittoPossibility.includes(emailDomain)) {
      return "Você quis dizer @voitto.com.br ?";
    } else if (yahooPossibility.includes(emailDomain)) {
      return "Você quis dizer @yahoo.com ?";
    } else if (hotmailPossibility.includes(emailDomain)) {
      return "Você quis dizer @hotmail.com ?";
    } else {
      return null;
    }
  };

  if (!email || email === null || email === "") {
    return "O email não pode ser vazio";
  }

  const splitEmail = email.split("@");

  if (
    splitEmail.length < 2 ||
    splitEmail[0]?.length < 1 ||
    splitEmail[1]?.length < 3
  ) {
    return "O email deve ser válido";
  }

  if (completeValidation) {
    const messageMistake = emailMistakes();
    if (messageMistake) {
      return messageMistake;
    }
  }

  return "";
};

export const phoneValidate = (phone) => {
  if (!phone || phone?.length === 0) {
    return "Digite um número de telefone";
  }
  const phoneRegex = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;

  const cleanPhone = phone.replace(/_/g, "");

  if (cleanPhone.length > 15) {
    let contadorDeNaoNumeros = 0;

    for (let i = 0; i < cleanPhone?.length; i++) {
      if (isNaN(parseInt(cleanPhone.charAt(i)))) {
        contadorDeNaoNumeros++;
      }
    }

    if (contadorDeNaoNumeros < 4) {
      return "Formato inválido";
    }
  } else {
    let celularSemTraco = cleanPhone?.replace(/_/g, "");
    celularSemTraco = celularSemTraco?.replace(/-/, "");

    if (!phoneRegex.test(celularSemTraco)) {
      return "Formato inadequado";
    }
  }
};

export const cpfValidation = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf === "") return "CPF inválido";

  if (
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return "CPF Inválido";
  }

  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let rev = 11 - (add % 11);

  if (rev === 10 || rev === 11) {
    rev = 0;
  }

  if (rev !== parseInt(cpf.charAt(9))) {
    return "CPF Inválido";
  }

  add = 0;

  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10))) return "CPF Inválido";
  return null;
};

export const birthdayValidate = (value) => {
  if (value === null || value === "" || value === "0000-00-00") {
    return "Insira uma data";
  }

  const dataInserted = new Date(value);
  const today = new Date();

  if (today.getFullYear() - dataInserted.getFullYear() >= 10) {
    return null;
  }
  return "Insira a sua data de nascimento";
};

export const mandatoryValidate = (value) => {
  if (value.length === 0) {
    return "Campo obrigatório";
  }

  return null;
};

export const mandatorNumberValidate = (value) => {
  if (value === null) {
    return "Campo obrigatório";
  }

  return null;
};

export const checkMobileComplete = (value) => {
  if (!value) {
    return false;
  }

  let counterNoNumbers = 0;

  for (let i = 0; i < value?.length; i++) {
    if (isNaN(parseInt(value.charAt(i)))) {
      counterNoNumbers++;
    }
  }

  return counterNoNumbers === 4;
};

export const cepValidate = async (cep) => {
  const formatedCep = cep.replace("-", "");
  if (!formatedCep) {
    return { status: false, data: { error: "O CEP não pode ser vazio" } };
  }

  Axios.get(`https://viacep.com.br/ws/${formatedCep}/json/`)
    .then((res) => {
      if (!res.data.erro) {
        return {
          status: true,
          data: {
            endereco: res.data.logradouro,
            bairro: res.data.bairro,
            cidade: res.data.localidade,
            estado: res.data.uf,
          },
        };
      }

      return { status: false, data: { error: "CEP Inválido" } };
    })
    .catch((err) => {
      console.error(err);
      return { status: false, data: { error: err } };
    });
};

export const isGoogleAccount = async () => {
  return await producaov2
    .get(`auth/google/pessoa/${getUserNode().id}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const validatePayment = async (id_pedido, response, id_curso, card_params, message) => {
  const retorno = await producaov2.get(`/pedido/${id_pedido}/status`)
    .then(async res => {
      if (res.data.status == 0) {
        if (response.data.item.orderStatus == 'paid') {
          await producaov2.post(
            '/pagamento/certificadoPending', { id_pedido, id_curso },
            {
              headers: {
                access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
              }
            }
          );
        }

        return 'success'
      } else {
        if (!res.data.status != null && res.data.status != undefined && res.data.status != 70) {
          return 'Ocorreu um erro com os dados do seu cartão. Por favor revise e tente novamente.'
        }
        return 'invalido';
      }
    }).catch(async err => {
      await producaov2.post('user-logs', {
        id_pessoa: getUserNode().id,
        url: 'sitereactssr/pagar catch - creditPayment',
        object: JSON.stringify(err),
        description: JSON.stringify(message)
      }).catch(err => {
        console.log(err);
      })
    })
  return retorno;
};
